<template>
  <div class="WarehousesRequestsTable">
    <app-table-dropdown
      route="warehouses"
      :isHeaderLink="false"
      :response="list"
      :clear="true"
      :isDropdown="false"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span class="app-table-dropdown__table-header-title">
            Название склада
          </span>
          <span
            class="app-table-dropdown__table-header-title"
            v-if="!responsive.isSm"
          >
            Адрес склада
          </span>
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title"
          >
            Дата и время заявки
          </span>
          <span class="app-table-dropdown__table-header-title"> Статус </span>
        </div>
      </template>

      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div class="app-table-dropdown__row-header-default-item">
            {{ item.request.name }}
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item"
          >
            {{ item.request.address }}
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item"
          >
            {{ item.createdAt | dateFormat('dd.MM.yyyy HH:mm') }}
          </div>
          <div class="app-table-dropdown__row-header-default-item">
            {{ $options.STATUSES[item.status] }}
          </div>
        </div>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import { SELLER_WAREHOUSES_REQUESTS } from '@/helpers/enums/statuses';

export default {
  name: 'WarehousesRequestsTable',
  inject: ['responsive'],
  components: {
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.$options.STATUSES = SELLER_WAREHOUSES_REQUESTS;
  },
};
</script>

<style lang="scss" scoped>
.WarehousesRequestsTable {
  // -
}
</style>
